
import DefaultLayout from "~/layouts/default.vue";

export default {
  components: {
    DefaultLayout,
  },
};
